exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nselect {\n  height: 4rem;\n}\n.quick-message {\n      background: white !important;\n      border-radius: 5px !important;\n      border: 1px solid #D1D1D1 !important;\n      margin-bottom: 0 !important;\n      height: 100% !important;\n      opacity: 1 !important;\n}\n", ""]);

// exports
